import { createAction } from 'redux-actions';

export const VIDEO_CARDS_CLEANUP = 'WIDGET.VIDEO_CARDS.CLEANUP';
export const cleanupVideoCards = createAction(VIDEO_CARDS_CLEANUP);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/video-cards/cleanup.js